import { render, staticRenderFns } from "./FrzCustomersMaturation.vue?vue&type=template&id=68bf90c7"
import script from "./FrzCustomersMaturation.vue?vue&type=script&lang=js"
export * from "./FrzCustomersMaturation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports